export default __webpack_public_path__ + "images/nu-770e6779515b496ac3b67e6f0a207c7e.svg";